import useAppShell from 'AppShell/index';
import { SignupAndLoginBellaProps } from 'AppShell/types';
import { PageType } from 'Types/types';

const defaultHostProps: SignupAndLoginBellaProps = {
    pageType: PageType.UNKNOWN,
    isShopToClubEnabled: false,
    badgeBackgroundColor: '',
};

export const useHostProps = (): SignupAndLoginBellaProps => useAppShell()?.hostProps || defaultHostProps;
